import { render } from "./RequestApprovedPage.vue?vue&type=template&id=72dc1f52&scoped=true&ts=true"
import script from "./RequestApprovedPage.vue?vue&type=script&lang=ts"
export * from "./RequestApprovedPage.vue?vue&type=script&lang=ts"

import "./RequestApprovedPage.vue?vue&type=style&index=0&id=72dc1f52&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dc1f52"]])

export default __exports__